import React, {useEffect, useState} from "react";
import { MultiSelect } from "primereact/multiselect";
import { Field } from "formik";

export default function NSMultiSelect({
                                                 startVal,
                                                 formikRef = null,
                                                 name,
                                                 options = [],
                                                 onChangeSelect = () => {
                                                 },
                                                 invalid
                                             }) {

    const [selectedMultiSelect, setSelectedMultiSelect] = useState(null);

    useEffect(() => {
        setSelectedMultiSelect(startVal ? startVal.split(',') : null);
    }, [options]);

    return options && (
       <Field 
            name={name}
            component={MultiSelect}
            value={selectedMultiSelect !== '' ? selectedMultiSelect : null}
            onChange={(e) => {
                let newVal = e.value.length > 0 ? e.value.join(',') : '';
                formikRef.current.setFieldValue(name, newVal);
                onChangeSelect(newVal);
            }} 
            options={options} 
            optionLabel="label" 
            display="chip"
            maxSelectedLabels={10} 
            className="w-100 md:w-20rem"
            invalid={invalid}
            />
    )
}